:host {
  @apply block;
}

:host(:focus) {
  @apply outline-none;
}

@include base-component();
